import { render, staticRenderFns } from "./Simples.vue?vue&type=template&id=49de8f96&"
import script from "./Simples.vue?vue&type=script&lang=js&"
export * from "./Simples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports